import { type LocationResult } from 'app/services/chatBot';
import { format } from 'date-fns';

export const getLocationStatusAndHours = (
  location: LocationResult,
  currentDate: Date = new Date()
): { isOpen: boolean; hours?: string } => {
  let isOpen = !location.opens_at;

  const currentWeekdayName = format(currentDate, 'iiii').toLowerCase();
  const regexp = new RegExp(`${currentWeekdayName}: (.*)`, 'i');

  let hours;

  for (const schedule of location.full_hours ?? []) {
    const result = schedule.match(regexp);
    if (result) {
      hours = result[1].toLowerCase();

      // Watch for schedules of the form 'Sunday: Closed'
      if (/closed/i.test(hours)) {
        isOpen = false;
        hours = undefined;
      }

      break;
    }
  }

  return { isOpen, hours };
};
